import React from 'react';

// Summary: Standalone chef-hat glyph (FontAwesome free-solid has no bare chef-hat icon —
// faKitchenSet bundles a whisk with the hat). Original artwork: three puffed lobes on top
// of a straight band, filled with the tile's tone color, outlined in white like a badge.
export const ChefHatIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="currentColor"
        stroke="#fff"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M12 1.2c-2.55 0-4.6 1.9-4.78 4.3-2.4.2-4.22 2.1-4.22 4.4 0 2.15 1.6 3.95 3.72 4.3-.15 1.1-.25 2.35-.32 3.4h11.2c-.07-1.05-.17-2.3-.32-3.4 2.12-.35 3.72-2.15 3.72-4.3 0-2.3-1.82-4.2-4.22-4.4C16.6 3.1 14.55 1.2 12 1.2Z" />
        <path d="M6.4 18.6h11.2v2.85a.9.9 0 0 1-.9.9H7.3a.9.9 0 0 1-.9-.9V18.6Z" />
        <path d="M12 5c0-.7.13-1.4.38-2" fill="none" stroke="currentColor" strokeWidth="0.9" />
        <path d="M6.9 5.6c-.45.9-.7 1.9-.7 2.95" fill="none" stroke="currentColor" strokeWidth="0.9" />
        <path d="M17.1 5.6c.45.9.7 1.9.7 2.95" fill="none" stroke="currentColor" strokeWidth="0.9" />
    </svg>
);
